import styled, { css } from "styled-components";
import Button from "../../../../Button";

interface ButtonProps {
    color?: string;
}

export const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 5px;
    flex-direction: column;
    align-items: flex-start;
`;

export const Btn = styled(Button)<ButtonProps>`
    width: auto;
    height: 36px;
    background-color: #f23b5c;
    color: #fff;
    border: none;
    cursor: pointer;    
    font-weight: 500;    
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s ease;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 14px;

    ${props => props.color && css`
        background-color: ${props.color};
    `}
    
    &:hover {
        opacity: 0.8;        
    }

`;

export const LastClickDetails = styled.div`
    margin-top: 7px;
    font-size: 13px;
    font-style: italic;
`;